<template>
  <li class="task-item">
    <section class="task-item__card">
      <div class="task-item__card-t">
        <h4 class="name">{{ task.taskName }}</h4>
        <p :class="['detail', isView && 'active']" @click="viewDetail">
          查看详情
          <img src="../assets/images/icon_user_arrow.png" alt="" />
        </p>
      </div>
      <div class="task-item__card-b" v-show="task.rewards.length > 0">
        <p class="tool">可得</p>
        <ul>
          <li
            :class="['cash', reward.rewardType === 'MEMBER' && 'members']"
            v-for="(reward, index) in task.rewards"
            :key="index"
          >
            <span class="num">{{ reward.name }}</span>
            <span class="img">{{ reward.rewardType | filterRewardsText }}</span>
          </li>
        </ul>
      </div>
    </section>
    <transition name="">
      <section :class="['task-item__content', isView && 'active']">
        <p class="content-desc">完成以下全部条件，可获得奖励</p>
        <ul class="content-list">
          <li>
            <!-- <h3 class="title"><span>阶段1</span>完成司机认证</h3> -->
            <!-- <h4 class="second__title">缴纳保证金</h4> -->
            <p class="validity">
              任务有效期:<span>
                {{ task.relativeTime }}
                {{ task.relativeTimeUnit | filterRelativeUnit }}</span
              >
            </p>
            <div
              v-for="(content, index) in task.peopleGroupRelations"
              :key="index"
            >
              <p
                v-for="(condition, num) in content.conditions"
                :class="[condition.type === 1 && 'city']"
                :key="num"
              >
                {{ condition.type | filterConditionType }}
                {{ condition.contents | filterContent }}
              </p>
            </div>
            <div
              v-if="
                task.verificationNumberPlates &&
                  task.verificationNumberPlates.length > 0
              "
            >
              <p>
                车牌限制：{{ task.verificationNumberPlates | filterCarContent }}
              </p>
            </div>
            <div
              v-if="
                task.verificationCities && task.verificationCities.length > 0
              "
            >
              <p>认证城市：{{ task.verificationCities | filterCarContent }}</p>
            </div>
            <!-- <p class="city">
              适用城市：深圳、广州、东莞等<img
                src="../assets/images/icon_question.png"
              />
            </p> -->
          </li>
        </ul>
      </section>
    </transition>
  </li>
</template>
<script>
import { mapState } from 'vuex';
import { rewardsCollection } from '../utils/index';
export default {
  props: ['task'],
  data() {
    return {
      isView: false
    };
  },
  computed: {
    ...mapState('app', ['activityCode'])
  },
  filters: {
    filterRewardsText(type) {
      return rewardsCollection[type].desc;
    },
    filterRelativeUnit(type) {
      if (type === 0) {
        return '天';
      } else if (type === 1) {
        return '周';
      } else {
        return '月';
      }
    },
    filterConditionType(type) {
      if (type === 3) {
        return '受邀用户范围:';
      } else if (type === 1) {
        return '适用城市:';
      }
    },
    filterContent(contents) {
      return contents.map(content => content.name).join('、');
    },
    filterCarContent(contents) {
      return contents.join('、');
    }
  },
  methods: {
    viewDetail() {
      this.isView = !this.isView;
      if (!this.isView) {
        this.trackLog('查看详情', false, {
          actEventType: 'invite_tasklist_click',
          task_ids: this.task.taskId
        });
      }
    }
  }
};
</script>
<style lang="less" scoped>
.task-item {
  margin-top: 24px;
  // box-shadow: 0px 8px 18px 0px #ecf1f5;
  border-radius: 32px;
  background-color: rgba(255, 255, 255, 0.6);
  &__card {
    background: #f4f5f6;
    border-radius: 32px;
    padding: 30px;
    &-t {
      font-family: Source Han Sans SC Bold, Source Han Sans SC Bold-Bold;
      text-align: left;
      color: #181d37;
      letter-spacing: 1px;
      .fs;
      justify-content: space-between;
      .name {
        font-size: 32px;
        font-weight: 700;
        max-width: 405px;
        .ellipsis;
      }
      .detail {
        font-size: 24px;
        font-weight: 500;
        color: rgba(24, 29, 55, 0.85);
        .fc;
        &.active {
          img {
            transform: rotate(180deg);
          }
        }
        > img {
          width: 17px;
          margin-left: 8px;
          transition: transform 1s;
        }
      }
    }
    &-b {
      display: flex;
      margin-top: 30px;

      .tool {
        font-size: 28px;
        font-family: Source Han Sans SC Medium, Source Han Sans SC Medium-Medium;
        font-weight: 500;
        text-align: left;
        color: rgba(24, 29, 55, 0.85);
        letter-spacing: 1px;
        line-height: 60px;
      }
      > ul {
        > li {
          .fs;
          margin-left: 10px;
          margin-bottom: 10px;
          > span {
            font-size: 28px;
            font-family: Source Han Sans SC Bold, Source Han Sans SC Bold-Bold;
            font-weight: 700;
            text-align: center;
            color: #f51919;
            letter-spacing: 1px;
            height: 60px;
            line-height: 60px;
            box-sizing: border-box;
            &.img {
              padding: 0 20px 0 25px;
              background-image: url(../assets/images/icon_cash.png);
              background-repeat: no-repeat;
              background-size: cover;
              color: #fff;
            }
            &.num {
              background: #ffdad7;
              border-top-left-radius: 16px;
              border-bottom-left-radius: 16px;
              padding: 0 24px;
            }
          }
        }
        .members {
          .num {
            background: #feefb9;
            color: #3434de;
          }
          .img {
            background-image: url(../assets/images/icon_members.png);
            color: #ae0000;
          }
        }
      }
    }
  }
  &__content {
    font-size: 26px;
    font-family: Source Han Sans SC Medium, Source Han Sans SC Medium-Medium;
    font-weight: 500;
    color: #181d37;
    letter-spacing: 1px;
    padding: 0 30px;
    overflow: hidden;
    max-height: 0px;
    transition: max-height 0.5s;

    &.active {
      max-height: 700px;
    }
    .content-desc {
      margin-top: 30px;
      margin-bottom: 22px;
    }
    .content-list {
      margin-bottom: 30px;
      li {
        .title {
          font-size: 32px;
          font-weight: 700;
          margin-bottom: 22px;
          > span {
            display: none;
            padding: 6px 14px;
            opacity: 1;
            background: #fff2da;
            border-radius: 12px;
            font-weight: 500;
            color: #ae0000;
            margin-right: 15px;
          }
        }
        .second__title,
        p {
          font-size: 26px;
          // margin-bottom: 22px;
          color: rgba(24, 29, 55, 0.85);
          line-height: 46px;
          font-weight: 300;
          .fs;
        }
        .validity {
          font-weight: 300;
          > span {
            color: #ff5a28;
          }
        }
        .city {
          > img {
            width: 28px;
          }
        }
      }
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  //指就是html中fade名称
  transition: opacity 1s; //0.5s动画过渡的时间
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
